import { Select, styled } from "@mui/material";
import { IStyledSelectProps } from "./types";

const StyledSelect = styled(Select)<IStyledSelectProps>(({ theme }) => ({
    backgroundColor: (theme.palette as any).neutral?.darker || theme.palette.background.paper,
    transition: 'all 0.2s ease-in-out',
    height: '36px', // Altura pequena
    minHeight: '36px',
    border: 'none !important',
    outline: 'none !important',
    boxShadow: 'none !important',

    '& .MuiSelect-icon': {
        color: theme.palette.primary.main,
        transition: 'transform 0.2s ease-in-out',
    },

    '&.Mui-focused .MuiSelect-icon': {
        color: theme.palette.primary.main,
    },

    '&.Mui-error .MuiSelect-icon': {
        color: theme.palette.error.main,
    },

    '& fieldset': {
        border: 'none !important',
        borderWidth: '0 !important',
        borderStyle: 'none !important',
        display: 'none !important',
        visibility: 'hidden !important',
        opacity: '0 !important',
        padding: '0 !important',
        margin: '0 !important',
    },

    '& .MuiOutlinedInput-notchedOutline': {
        border: 'none !important',
        borderWidth: '0 !important',
        borderStyle: 'none !important',
        display: 'none !important',
        visibility: 'hidden !important',
        opacity: '0 !important',
        padding: '0 !important',
        margin: '0 !important',
    },

    '&:hover fieldset': {
        border: 'none !important',
        borderWidth: '0 !important',
        display: 'none !important',
    },

    '&:hover .MuiOutlinedInput-notchedOutline': {
        border: 'none !important',
        borderWidth: '0 !important',
        display: 'none !important',
    },

    '&.Mui-focused fieldset': {
        border: 'none !important',
        borderWidth: '0 !important',
        display: 'none !important',
    },

    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
        border: 'none !important',
        borderWidth: '0 !important',
        display: 'none !important',
    },

    '&.Mui-error fieldset': {
        border: 'none !important',
        borderWidth: '0 !important',
        display: 'none !important',
    },

    '&.Mui-error .MuiOutlinedInput-notchedOutline': {
        border: 'none !important',
        borderWidth: '0 !important',
        display: 'none !important',
    },

    '& .MuiSelect-select .MuiInputBase-input::placeholder': {
        color: theme.palette.text.secondary,
        opacity: 0.8,
    },

    '& .MuiSelect-select:-ms-input-placeholder': {
        color: theme.palette.text.secondary,
        opacity: 0.8,
    },

    '& .MuiSelect-select::-ms-input-placeholder': {
        color: theme.palette.text.secondary,
        opacity: 0.8,
    },

    '& .MuiSelect-select': {
        color: theme.palette.text.primary,
        padding: theme.spacing(1, 1.5),
        paddingRight: `${theme.spacing(6)} !important`,
        height: '100%',
        display: 'flex',
        alignItems: 'center',
    },

    '&:hover': {
        backgroundColor: (theme.palette as any).neutral?.darker || theme.palette.action.hover,
    },

    '&.Mui-focused': {
        backgroundColor: (theme.palette as any).neutral?.darker || theme.palette.background.paper,
    },

    '&.Mui-disabled': {
        backgroundColor: theme.palette.action.disabledBackground,
        '& .MuiSelect-icon': {
            color: theme.palette.action.disabled,
        },
    },
}))

export { StyledSelect }